/**
 * Виджеты для дашборда. Модуль для работы с API
 * @module widgets
 */

import { buildQueryParams, cleanParams } from "@/utils";

/**
 * Получение списка контактов
 * @param {String} search - поиск по email, должности, фио
 * @returns {Promise} - данные пользователей
 * @throws {Error} - ошибка при получении данных
 */
export const getContacts = async (search) => {
  const cleanedFilters = cleanParams({ search });
  const queryString = buildQueryParams(cleanedFilters);

  try {
    const response = await fetch(`/api/widgets/contacts?${queryString}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data.contacts;
  } catch (err) {
    throw err;
  }
};

/**
 * Получение списка всех задач по статусам
 * @param {Object} params - параметры фильтрации
 * @returns {Promise} - данные задач
 * @throws {Error} - ошибка при получении данных
 */
export const getAllStatistics = async (params) => {
  const cleanedFilters = cleanParams(params);
  const queryString = buildQueryParams(cleanedFilters);

  try {
    const response = await fetch(`/api/widgets/tasks/stats?${queryString}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data;
  } catch (err) {
    throw err;
  }
};

/**
 * Получение списка истекающих по сроку задач
 * @param {Object} params - параметры фильтрации
 * @returns {Promise} - данные задач
 * @throws {Error} - ошибка при получении данных
 */
export const getDeadlines = async (params) => {
  const cleanedFilters = cleanParams(params);
  const queryString = buildQueryParams(cleanedFilters);

  try {
    const response = await fetch(`/api/widgets/tasks/expiring?${queryString}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data.tasks;
  } catch (err) {
    throw err;
  }
};

/**
 * Получение списка просроченных задач
 * @param {Object} params - параметры фильтрации
 * @returns {Promise} - данные задач
 * @throws {Error} - ошибка при получении данных
 */
export const getOverdueTasks = async (params) => {
  const cleanedFilters = cleanParams(params);
  const queryString = buildQueryParams(cleanedFilters);

  try {
    const response = await fetch(`/api/widgets/tasks/overdue?${queryString}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data.tasks;
  } catch (err) {
    throw err;
  }
};
